import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import Sidebar from '../components/layout/Sidebar';

export class AppBody extends Component {
    static displayName = AppBody.name;
    

    render() {
        var currentYear = (new Date().getFullYear())

        return (
            <div className='page-content'>
                <NavMenu />
                <Sidebar />
                <Container>
                    {this.props.children}
                </Container>
                <footer>
                    <hr />
                    <p>&copy; {currentYear} - TIC-MS, Inc. All Rights Reserved</p>
                </footer>
            </div>
        );
    }
}
